import { useMutation } from 'react-query'

import { settingsService } from 'src/services/settings.service'
import { ISendTgCustomMessageDto } from 'src/types'

export const useSendTgCustomMessage = () => {
  return useMutation((dto: ISendTgCustomMessageDto) => settingsService.sendTgCustomMessage(dto), {
    onSuccess(data, vars) {
      if (!data) {
        return
      }
    },
  })
}
